import { render, staticRenderFns } from "./BagItemBurritosByTheBox.vue?vue&type=template&id=4de4521e"
import script from "./BagItemBurritosByTheBox.vue?vue&type=script&lang=js"
export * from "./BagItemBurritosByTheBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports